import type { StateService } from "@uirouter/angularjs";
import type { IScope, IWindowService } from "angular";

import type { IEquipmentFunctionalityType, IResponseWithLoading } from "App/Modules/Models";
import { DirectConnectionType } from "App/Modules/Models/Models/DirectConnectionType";
import type { IAvailableChannel } from "App/Modules/Models/Models/IAvailableChannel";
import type { IModalService } from "App/Modules/Services";

export default class IOPropertiesComponentController {
    public static $inject: string[] = ["$scope", "$state", "$window", "mmModalService"];

    public equipmentFunctionalityType: IResponseWithLoading<IEquipmentFunctionalityType>;

    constructor(
        private readonly $scope: IScope,
        private readonly stateService: StateService,
        private readonly $window: IWindowService,
        private readonly modalService: IModalService,
    ) {}

    public editIOProperties() {
        this.modalService
            .open<IEquipmentFunctionalityType, void>(
                "irEditFunctionalityIoProperties",
                this.equipmentFunctionalityType.data,
            )
            .subscribe(
                (editResponse) => {
                    if (editResponse) {
                        this.equipmentFunctionalityType.data = editResponse;
                    }
                },
                (reason) => reason,
            );
    }

    public getSupportedConnectionTypes(channel: IAvailableChannel) {
        return channel.supportedDirectConnections
            .map((connection: DirectConnectionType) => DirectConnectionType[connection])
            .sort()
            .join(", ");
    }
}
